/* "See it in your room": upload a room photo, get a daylight and a lit-at-night
   render of this product installed in it. The photo is downscaled in the
   browser before it is sent, so uploads stay small and quick. */
(function () {
  'use strict';

  var MAX_EDGE = 1400;
  var STATUS = [
    'Reading the room',
    'Measuring the space against the furniture',
    'Placing the piece',
    'Matching your daylight',
    'Rendering the daytime view',
    'Waiting for dusk',
    'Turning the lamp on',
    'Casting the pattern across the walls',
    'Finishing the night view'
  ];

  function shrink(file) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        var w = img.naturalWidth, h = img.naturalHeight;
        var scale = Math.min(1, MAX_EDGE / Math.max(w, h));
        var cw = Math.round(w * scale), ch = Math.round(h * scale);
        var c = document.createElement('canvas');
        c.width = cw; c.height = ch;
        c.getContext('2d').drawImage(img, 0, 0, cw, ch);
        URL.revokeObjectURL(url);
        resolve(c.toDataURL('image/jpeg', 0.86));
      };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('bad image')); };
      img.src = url;
    });
  }

  /* A render costs real money and 45 seconds, so the result is kept per product
     and restored on refresh or back-navigation. Only "Try another photo"
     clears it. Kept to the two most recent products to stay inside quota. */
  var STORE_KEY = 'hoaTryStore';

  function readStore() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || '{}'); } catch (e) { return {}; }
  }
  function writeStore(obj) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(obj)); } catch (e) {
      /* quota: drop everything but the newest entry and retry once */
      try {
        var keys = Object.keys(obj).sort(function (a, b) { return (obj[b].ts || 0) - (obj[a].ts || 0); });
        var trimmed = {};
        if (keys[0]) trimmed[keys[0]] = obj[keys[0]];
        localStorage.setItem(STORE_KEY, JSON.stringify(trimmed));
      } catch (e2) {}
    }
  }
  function saveResult(handle, data) {
    var all = readStore();
    all[handle] = { day: data.day, night: data.night || null, ts: Date.now() };
    var keys = Object.keys(all).sort(function (a, b) { return (all[b].ts || 0) - (all[a].ts || 0); });
    var keep = {};
    keys.slice(0, 2).forEach(function (k) { keep[k] = all[k]; });
    writeStore(keep);
  }
  function loadResult(handle) {
    var all = readStore();
    return all[handle] || null;
  }
  function clearResult(handle) {
    var all = readStore();
    delete all[handle];
    writeStore(all);
  }

  /* Owner bypass: append ?hoatest=<token> once and it is remembered on this
     browser, so testing the live store never eats the public quota. */
  /* A stable per-browser id so the allowance follows the person, not the
     network. Resettable by design; the IP and global caps are the real guard. */
  function visitorId() {
    try {
      var v = localStorage.getItem('hoaTryVisitor');
      if (!v) {
        v = 'v' + Date.now().toString(36) + Math.random().toString(36).slice(2, 12);
        localStorage.setItem('hoaTryVisitor', v);
      }
      return v;
    } catch (e) { return null; }
  }

  function bypassToken() {
    try {
      var m = location.search.match(/[?&]hoatest=([^&]+)/);
      if (m) {
        localStorage.setItem('hoaTryBypass', decodeURIComponent(m[1]));
      }
      return localStorage.getItem('hoaTryBypass') || null;
    } catch (e) { return null; }
  }

  function init(root) {
    if (root.getAttribute('data-try-wired')) return;
    root.setAttribute('data-try-wired', '1');

    var handle = root.getAttribute('data-handle');
    var endpoint = root.getAttribute('data-endpoint');
    var q = function (s) { return root.querySelector(s); };

    var drop = q('[data-try-drop]'), input = q('[data-try-input]');
    var prevImg = q('[data-try-preview]'), bar = q('[data-try-bar]'), elapsedEl = q('[data-try-elapsed]');
    var pending = q('[data-try-pending]'), pendingTime = q('[data-try-pending-time]');
    var pendTicker = null;
    var ready = q('[data-try-ready]'), thumb = q('[data-try-thumb]');
    var loading = q('[data-try-loading]'), status = q('[data-try-status]');
    var result = q('[data-try-result]'), dayImg = q('[data-try-day]'), nightImg = q('[data-try-night]');
    var errBox = q('[data-try-error]'), goBtn = q('[data-try-go]');
    var dl = q('[data-try-download]');
    var payload = null, timer = null;

    function applyResult(saved) {
      dayImg.src = saved.day;
      nightImg.src = saved.night || saved.day;
      dayImg.classList.add('is-on');
      nightImg.classList.remove('is-on');
      var nightBtn = root.querySelector('[data-try-mode="night"]');
      root.querySelectorAll('[data-try-mode]').forEach(function (b) {
        b.classList.toggle('is-on', b.getAttribute('data-try-mode') === 'day');
      });
      if (nightBtn) {
        nightBtn.disabled = !saved.night;
        nightBtn.textContent = saved.night ? 'Lit at night' : 'Night view unavailable';
      }
      if (dl) dl.setAttribute('href', dayImg.src);
      show(result);
    }

    function show(el) {
      [drop, ready, loading, result].forEach(function (n) { if (n) n.hidden = n !== el; });
    }
    function fail(msg) {
      errBox.hidden = false;
      errBox.textContent = msg;
    }
    function clearError() { errBox.hidden = true; errBox.textContent = ''; }

    function accept(file) {
      clearError();
      if (!file) return;
      if (!/^image\/(jpeg|png|webp)$/.test(file.type)) {
        return fail('That file type is not supported. Please use a JPG or PNG photo.');
      }
      if (file.size > 20 * 1024 * 1024) {
        return fail('That photo is very large. Please pick one under 20 MB.');
      }
      shrink(file).then(function (dataUrl) {
        payload = dataUrl;
        thumb.src = dataUrl;
        show(ready);
      }).catch(function () {
        fail('That photo could not be read. Please try another one.');
      });
    }

    var restored = loadResult(handle);
    if (restored && restored.day) applyResult(restored);

    input.addEventListener('change', function () { accept(input.files && input.files[0]); });

    ['dragenter', 'dragover'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); });
    });
    drop.addEventListener('drop', function (e) {
      var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      accept(f);
    });

    q('[data-try-change]').addEventListener('click', function () { input.click(); });
    q('[data-try-again]').addEventListener('click', function () {
      payload = null; input.value = ''; clearError();
      clearResult(handle);
      show(drop);
    });

    root.querySelectorAll('[data-try-mode]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mode = btn.getAttribute('data-try-mode');
        root.querySelectorAll('[data-try-mode]').forEach(function (b) { b.classList.toggle('is-on', b === btn); });
        dayImg.classList.toggle('is-on', mode === 'day');
        nightImg.classList.toggle('is-on', mode === 'night');
        if (dl) dl.setAttribute('href', mode === 'night' ? nightImg.src : dayImg.src);
      });
    });

    function req(body) {
      var bp = bypassToken();
      if (bp) body.bypass = bp;
      var vid = visitorId();
      if (vid) body.visitor = vid;
      return fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, d: d }; });
      });
    }

    /* the render runs as a background job on the server, so the browser starts
       it and then polls. No long-held connection means no endless spinner. */
    function runStage(body, budgetMs) {
      return req(body).then(function (res) {
        if (!res.ok || !res.d || !res.d.jobId) {
          var e = new Error('start failed');
          e.safe = (res.d && res.d.error) || 'The preview could not be generated. Please try again.';
          throw e;
        }
        var jobId = res.d.jobId;
        var started = Date.now();
        return new Promise(function (resolve, reject) {
          (function poll() {
            if (Date.now() - started > budgetMs) {
              var t = new Error('timeout');
              t.safe = 'That took longer than expected. Please try again, or use a smaller photo.';
              return reject(t);
            }
            fetch(endpoint + '?job=' + encodeURIComponent(jobId), { cache: 'no-store' })
              .then(function (r) { return r.json(); })
              .then(function (d) {
                if (d && d.status === 'done') return resolve(d);
                if (d && d.status === 'error') {
                  var e = new Error('job error');
                  e.safe = d.error || 'The preview could not be generated. Please try again.';
                  return reject(e);
                }
                setTimeout(poll, 4000);
              })
              .catch(function () { setTimeout(poll, 5000); });
          })();
        });
      });
    }

    var ticker = null;

    /* A real progress bar against a known ~40s estimate, plus the shopper's own
       photo behind it, so the wait shows visible movement instead of a spinner. */
    function beginStage(step, estimateMs) {
      var started = Date.now();
      root.querySelectorAll('[data-try-step]').forEach(function (el) {
        var n = Number(el.getAttribute('data-try-step'));
        el.classList.toggle('is-on', n === step);
        el.classList.toggle('is-done', n < step);
      });
      var msgs = step === 1
        ? ['Reading the room', 'Measuring against your furniture', 'Placing the piece', 'Matching your daylight', 'Finishing the daytime view']
        : ['Waiting for dusk', 'Turning the lamp on', 'Casting the pattern across the walls', 'Finishing the night view'];
      var i = 0;
      status.textContent = msgs[0];
      clearInterval(ticker);
      ticker = setInterval(function () {
        var ms = Date.now() - started;
        var pct = Math.min(95, (ms / estimateMs) * 100);
        if (bar) bar.style.width = pct.toFixed(1) + '%';
        if (elapsedEl) elapsedEl.textContent = Math.round(ms / 1000) + 's';
        var want = Math.min(msgs.length - 1, Math.floor(ms / (estimateMs / msgs.length)));
        if (want !== i) { i = want; status.textContent = msgs[i]; }
      }, 400);
    }
    function endStage() {
      clearInterval(ticker);
      if (bar) bar.style.width = '100%';
    }

    goBtn.addEventListener('click', function () {
      if (!payload) return;
      clearError();
      if (prevImg) prevImg.src = payload;
      show(loading);
      goBtn.disabled = true;
      beginStage(1, 45000);

      function stop() {
        endStage();
        goBtn.disabled = false;
      }

      runStage({ handle: handle, image: payload, stage: 'day' }, 420000)
        .then(function (res) {
          endStage();
          dayImg.src = res.day;
          nightImg.src = res.day;
          dayImg.classList.add('is-on');
          nightImg.classList.remove('is-on');
          root.querySelectorAll('[data-try-mode]').forEach(function (b) {
            b.classList.toggle('is-on', b.getAttribute('data-try-mode') === 'day');
            if (b.getAttribute('data-try-mode') === 'night') {
              b.disabled = true;
              b.textContent = 'Lit at night';
            }
          });
          if (dl) dl.setAttribute('href', dayImg.src);
          saveResult(handle, { day: res.day });
          show(result);

          /* tell them plainly that a night view is on its way */
          if (pending) {
            pending.hidden = false;
            var pStart = Date.now();
            clearInterval(pendTicker);
            pendTicker = setInterval(function () {
              if (pendingTime) pendingTime.textContent = Math.round((Date.now() - pStart) / 1000) + 's';
            }, 500);
          }

          return runStage({ handle: handle, image: payload, stage: 'night', dayImage: res.day }, 420000)
            .then(function (nres) {
              stop();
              var btn = root.querySelector('[data-try-mode="night"]');
              nightImg.src = nres.night;
              saveResult(handle, { day: res.day, night: nres.night });
              clearInterval(pendTicker);
              if (pending) pending.hidden = true;
              if (btn) {
                btn.disabled = false;
                btn.textContent = 'Lit at night';
                btn.classList.add('just-ready');
                setTimeout(function () { btn.classList.remove('just-ready'); }, 3200);
              }
            })
            .catch(function () {
              stop();
              clearInterval(pendTicker);
              if (pending) pending.hidden = true;
              var btn = root.querySelector('[data-try-mode="night"]');
              if (btn) { btn.disabled = true; btn.textContent = 'Night view unavailable'; }
            });
        })
        .catch(function (err) {
          stop();
          show(ready);
          fail((err && err.safe) || 'We could not reach the preview service. Please check your connection and try again.');
        });
    });
  }

  /* Arriving from the homepage teaser at /products/<handle>#try: bring the tool
     into view and open the file picker focus, so the handoff feels continuous. */
  function honourDeepLink() {
    if (location.hash !== '#try') return;
    var root = document.querySelector('[data-hoa-try]');
    if (!root) return;
    var hdr = 0;
    try { hdr = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height'), 10) || 0; } catch (e) {}
    var y = window.scrollY + root.getBoundingClientRect().top - hdr - 24;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    root.classList.add('hoa-try--hailed');
    setTimeout(function () { root.classList.remove('hoa-try--hailed'); }, 2600);
  }

  function scan() { document.querySelectorAll('[data-hoa-try]').forEach(init); }
  scan();
  document.addEventListener('DOMContentLoaded', function () { scan(); setTimeout(honourDeepLink, 400); });
  window.addEventListener('hashchange', honourDeepLink);
  if (document.readyState !== 'loading') setTimeout(honourDeepLink, 500);
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 150); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
